import script from "./confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm.vue?vue&type=script&setup=true&lang=js"

import "./confirm.vue?vue&type=style&index=0&id=6d624fda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d624fda"]])

export default __exports__